import Plotly from "./plotly-hifi.min.js";
import createPlotlyComponent from "react-plotly.js/factory";

export default Plotly;

// a react plotly component
export const Plot = createPlotlyComponent(Plotly);
